var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLiveSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lucide Icons / radio"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2502 47.7498C2.50024 37.9998 2.50024 21.9998 12.2502 12.2498M19.4999 40.4999C13.7499 34.7499 13.7499 25.2499 19.4999 19.2499M40.4999 19.5001C46.2499 25.2501 46.2499 34.7501 40.4999 40.7501M47.7502 12.2498C57.5002 21.9998 57.5002 37.7498 47.7502 47.4998M35 30C35 32.7614 32.7614 35 30 35C27.2386 35 25 32.7614 25 30C25 27.2386 27.2386 25 30 25C32.7614 25 35 27.2386 35 30Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#00140B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 10",
    d: "M6.99958 7.00042L53.9394 53.9394",
    strokeWidth: 6,
    strokeLinecap: "round",
    stroke: "#FAF7F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 11",
    d: "M6.99958 7.00042L53.9394 53.9394",
    strokeWidth: 2,
    strokeLinecap: "round",
    stroke: "#002E19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLiveSessions);
export default __webpack_public_path__ + "static/media/no-live-sessions.67340bb76a1048ccc5fa80ca54a46d11.svg";
export { ForwardRef as ReactComponent };